import React, { useEffect, useRef } from "react";
import { Portal } from "@magento/venia-ui/lib/components/Portal";
import UIkit from "uikit";
import Icon from "../Icon";
import defaultClasses from "./modal.module.scss";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
var Modal = _ref => {
  var {
    classes: propClasses,
    id,
    nameClass,
    closeButtonClass,
    modalHeigthClass,
    modalFullScreen,
    modalCloseOutside,
    position = "vertical",
    canBeClosed = true,
    closeButton = true,
    modalDialogClass,
    onClose,
    classNameExtra,
    isOpen = false,
    isXlarge,
    animation,
    children,
    customZIndex,
    centeredModal = true
  } = _ref;
  var modalRef = useRef(null);
  var elementRef = useRef(null);
  var setBackgroundCloserHandler = () => {
    var handler = e => {
      // Check if the click target is inside the modal-content
      var isClickInsideModal = !!e.target.closest(".uk-modal-dialog");
      // Close the modal if the click is outside the modal content
      if (!isClickInsideModal && onClose && !modalCloseOutside) {
        onClose(e);
      }
    };
    var element = document.getElementById(id);
    // Add click event listener to the modal element
    element.addEventListener("click", handler);

    // Return a cleanup function to remove the event listener
    return () => {
      element.removeEventListener("click", handler);
    };
  };
  useEffect(() => {
    if (elementRef.current) {
      modalRef.current = UIkit.modal(elementRef.current);
      modalRef.current.container = document.getElementById("root");
      if (isOpen) {
        modalRef.current.show();
      } else {
        modalRef.current.hide();
      }
      var cleanupFunction;
      if (canBeClosed) {
        cleanupFunction = setBackgroundCloserHandler();
      }

      // Cleanup function for useEffect
      return () => {
        // This will be called when the component unmounts
        // or when isOpen or canBeClosed changes
        if (cleanupFunction) {
          cleanupFunction();
        }
      };
    }
  }, [isOpen, canBeClosed]);
  var classes = mergeClasses(defaultClasses, propClasses);
  var modalClass = classes[nameClass] ? classes[nameClass] : "";
  return /*#__PURE__*/React.createElement(Portal, {
    container: document.getElementById("root")
  }, /*#__PURE__*/React.createElement("div", {
    id: id,
    ref: elementRef,
    className: "component-modal ".concat(modalFullScreen ? "uk-modal-full" : "", " ").concat(classNameExtra ? classNameExtra : "", " ").concat(modalClass, " ").concat(classes.root ? classes.root : ""),
    "data-uk-modal": "bg-close: false; container: false; stack: true",
    style: customZIndex ? {
      zIndex: customZIndex
    } : {}
  }, /*#__PURE__*/React.createElement("div", {
    className: "uk-modal-dialog uk-flex uk-flex-column \n                    ".concat(modalDialogClass ? modalDialogClass : "", "\n                    ").concat(centeredModal ? "uk-flex-center " : "", "\n                    ").concat(defaultClasses.Width, " ").concat(modalHeigthClass ? modalHeigthClass : "", " \n                    ").concat(position ? position : "", "\n                    ").concat(animation ? animation : "uk-animation-slide-bottom", "\n                    "),
    "uk-height-viewport": isXlarge ? "offset-bottom: 20; offset-top: 20" : null
  }, canBeClosed && closeButton ? /*#__PURE__*/React.createElement("button", {
    className: "uk-modal-close ".concat(closeButtonClass || "", " ").concat(modalFullScreen ? "uk-modal-close-full" : "", "  ").concat(modalCloseOutside ? "uk-modal-close-outside" : ""),
    type: "button",
    onClick: onClose
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "icon-close",
    color: "white",
    header: true
  })) : null, children)));
};
export default Modal;